import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/search/'
export const CLEAR = NAMESPACE + 'CLEAR'
export const SET_QUERY = NAMESPACE + 'SET_QUERY'
export const SET_REFINERS = NAMESPACE + 'SET_REFINERS'
export const SET_SORT = NAMESPACE + 'SET_SORT'
export const SET = NAMESPACE + 'SET'

const initialState = {
  query: '',
  refiners: {
    desks: {},
    boards: {},
    cards: {},
    documents: {},
    comments: {},
  },
  limitToBoard: null,

  desks: [],
  desksCursor: null,
  desksRefiners: [],
  desksSort: 'relevancy',
  desksSortOptions: [],
  desksTotalCount: null,
  desksLoadedAll: false,
  desksLoading: true,

  boards: [],
  boardsCursor: null,
  boardsRefiners: [],
  boardsSort: 'relevancy',
  boardsSortOptions: [],
  boardsTotalCount: null,
  boardsLoadedAll: false,
  boardsLoading: true,

  cards: [],
  cardsCursor: null,
  cardsRefiners: [],
  cardsSort: 'relevancy',
  cardsSortOptions: [],
  cardsTotalCount: null,
  cardsLoadedAll: false,
  cardsLoading: true,

  documents: [],
  documentsCursor: null,
  documentsRefiners: [],
  documentsSort: 'relevancy',
  documentsSortOptions: [],
  documentsTotalCount: null,
  documentsLoadedAll: false,
  documentsLoading: true,

  comments: [],
  commentsCursor: null,
  commentsRefiners: [],
  commentsSort: 'relevancy',
  commentsSortOptions: [],
  commentsTotalCount: null,
  commentsLoadedAll: false,
  commentsLoading: true,

  users: [],
  usersCursor: null,
  usersRefiners: [],
  usersSort: 'relevancy',
  usersSortOptions: [],
  usersTotalCount: null,
  usersLoadedAll: false,
  usersLoading: true
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...initialState
      }
    case CLEAR:
      return {
        ...initialState,
        limitToBoard: state.limitToBoard
      }
    case SET_QUERY:
      return {
        ...initialState,
        query: action.payload,
        limitToBoard: state.limitToBoard
      }
    case SET_REFINERS:
      return {
        ...state,
        refiners: {
          ...state.refiners,
          ...action.payload,
        }
      }
    case SET_SORT:
      return {
        ...state,
        [`${action.payload.groupName}Sort`]: action.payload.sort
      }
    case SET:
      return {
        ...state,
        ...action.payload
      }
    default: return state
  }
}

export function clear () {
  return {
    type: CLEAR
  }
}

export function setQuery (query) {
  return {
    type: SET_QUERY,
    payload: query
  }
}

export function setRefiners (refiners) {
  return {
    type: SET_REFINERS,
    payload: refiners
  }
}

export function setSort ({ groupName, sort }) {
  return {
    type: SET_SORT,
    payload: {
      groupName,
      sort,
    }
  }
}

export function set (data) {
  return {
    type: SET,
    payload: data
  }
}
